<script>
export default {
    props: {
        title: String,
        className: String,
    }
}
</script>

<template>
  <div class="p-1" :class="className">
        <span class="small-card__title">{{title}}</span>
  </div>
</template>

<style lang="scss" scoped>
.small-card {
    background-image: linear-gradient(135deg, #e934d5, #6c3e9a);
}

.small-card__title {
    color: #fff;
    font-size: 12px;
    font-weight: normal;
}
</style>